import { ProyectoEstado } from 'src/utils/enums/ProyectoEstado';
import { ProyectoFormState } from './types';
import { colorMapping } from 'src/utils/enums/ProyectoEstado';
import {
  marcarPlanificadoProyectoF,
  marcarEnProcesoProyectoF,
  marcarDemoradoProyectoF,
  marcarFinalizadoProyectoF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ProyectoFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'proyectoForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusPlanificado(state) {
      state.status = {
        id: ProyectoEstado.Planificado,
        text: ProyectoEstado[ProyectoEstado.Planificado].toUpperCase(),
        color: colorMapping[ProyectoEstado.Planificado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarPlanificadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como planificado',
        },
        marcarEnProcesoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar en proceso al proyecto',
        },
        marcarDemoradoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como demorado',
        },
        marcarFinalizadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como finalizado',
        },
      };
    },
    setFormStatusEnProceso(state) {
      state.status = {
        id: ProyectoEstado.EnProceso,
        text: ProyectoEstado[ProyectoEstado.EnProceso].toUpperCase(),
        color: colorMapping[ProyectoEstado.EnProceso],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarPlanificadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como planificado',
        },
        marcarEnProcesoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar en proceso al proyecto',
        },
        marcarDemoradoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como demorado',
        },
        marcarFinalizadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como finalizado',
        },
      };
    },
    setFormStatusDemorado(state) {
      state.status = {
        id: ProyectoEstado.Demorado,
        text: ProyectoEstado[ProyectoEstado.Demorado].toUpperCase(),
        color: colorMapping[ProyectoEstado.Demorado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarPlanificadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como planificado',
        },
        marcarEnProcesoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar en proceso al proyecto',
        },
        marcarDemoradoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como demorado',
        },
        marcarFinalizadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como finalizado',
        },
      };
    },
    setFormStatusFinalizado(state) {
      state.status = {
        id: ProyectoEstado.Finalizado,
        text: ProyectoEstado[ProyectoEstado.Finalizado].toUpperCase(),
        color: colorMapping[ProyectoEstado.Finalizado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarPlanificadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como planificado',
        },
        marcarEnProcesoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar en proceso al proyecto',
        },
        marcarDemoradoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como demorado',
        },
        marcarFinalizadoProyectoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al proyecto como finalizado',
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(marcarPlanificadoProyectoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarPlanificadoProyectoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarEnProcesoProyectoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarEnProcesoProyectoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarDemoradoProyectoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarDemoradoProyectoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarFinalizadoProyectoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarFinalizadoProyectoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.proyecto.form.status;

export const selectMarcarPlanificadoProyectoF = (state: RootState) =>
  state.proyecto.form.actions?.marcarPlanificadoProyectoF;

export const selectMarcarEnProcesoProyectoF = (state: RootState) =>
  state.proyecto.form.actions?.marcarEnProcesoProyectoF;

export const selectMarcarDemoradoProyectoF = (state: RootState) =>
  state.proyecto.form.actions?.marcarDemoradoProyectoF;

export const selectMarcarFinalizadoProyectoF = (state: RootState) =>
  state.proyecto.form.actions?.marcarFinalizadoProyectoF;

export const selectGuardar = (state: RootState) =>
  state.proyecto.form.actions?.guardar;

// Export actions
export const {
  resetForm,

  setFormStatusPlanificado,
  setFormStatusEnProceso,
  setFormStatusDemorado,
  setFormStatusFinalizado,
} = formSlice.actions;

export default formSlice.reducer;
